<form autocomplete="off" class="theme-form">
  <div class="row">
    <div class="col-12">
      <app-input 
        [inputName]="'searchValue'" 
        [inputType]="'text'" 
        [inputId]="'searchValue'" 
        [inputValue]="searchValue"
        (inputValueEmit)="searchValue = $event; onSearchChange()" 
        (keydown)="onKeyDown($event)" 
        [inputClass]="'border-radius-0 border-bottom-0'"
        >
      </app-input>
    </div>
  </div>
  <app-svg-icon [name]="'cross_button_border'" class="cross_button_border"></app-svg-icon>
  <div class="cross-button cursorPointer">
    <app-svg-icon [name]="'cross'" [ngClass]="currentHoverEffect" (click)="confirmRowSelection()"></app-svg-icon>
  </div>
  <div class="pb-0">
    <div class="row mx-0 gap-2 d-flex flex-column h-100">
      <div class="col flex-fill p-0 h_22rem">
        <app-ag-grid 
          [dataModel]="agGridDataModel" 
          (gridReady)="onGridReady($event)" 
          (rowClicked)="handleRowClicked($event)"
          [columnSettings]="true" 
          [rowHeight]="27"
          >
        </app-ag-grid>
      </div>
    </div>
  </div>
</form>